import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTopButton = ({ targetRef, threshold = 200 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = (targetRef && targetRef.current) || (typeof window !== 'undefined' && window);
    if (!el) return undefined;

    const handleScroll = () => {
      const scrollTop = el === window ? (window.pageYOffset || document.documentElement.scrollTop) : el.scrollTop;
      setVisible(scrollTop > threshold);
    };

    handleScroll();
    el.addEventListener ? el.addEventListener('scroll', handleScroll) : window.addEventListener('scroll', handleScroll);

    return () => {
      el.removeEventListener ? el.removeEventListener('scroll', handleScroll) : window.removeEventListener('scroll', handleScroll);
    };
  }, [targetRef, threshold]);

  const scrollToTop = () => {
    const el = (targetRef && targetRef.current) || (typeof window !== 'undefined' && window);
    if (!el) return;
    if (el === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="fixed z-50 right-6 bottom-6 w-11 h-11 rounded-lg bg-primary-600 hover:bg-primary-700 text-white flex items-center justify-center shadow-lg transition-opacity"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
};

export default ScrollToTopButton;
